<p-dialog
  header="Print purchase orders"
  [(visible)]="printPdfModal"
  position="topright"
  [modal]="true"
  [style]="{ width: '50vw', height: '20vw' }"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  (onHide)="closePrinfPdfModal()">
  <p>PURCHASE ORDER TO INCLUDE</p>

  <p-table
    #dt
    [value]="purchaseOrderLine"
    styleClass="p-datatable-customers stockListing"
    [rowHover]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    [paginator]="false"
    [filterDelay]="0"
    [(selection)]="selectedPurchaseOrderLine"
    [rowHover]="true"
    dataKey="purchaseOrderNumber"
    selectionMode="multiple">
    <ng-template pTemplate="header">
      <tr>
        <th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
        <th class="type">Purchase order</th>
        <th class="descp">Name</th>
        <th class="descp">Quote</th>
        <th class="rest">Sent</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-purchaseOrderLine let-rowIndex="rowIndex">
      <tr class="p-selectable-row">
        <td>
          <p-tableCheckbox [value]="purchaseOrderLine"></p-tableCheckbox>
        </td>
        <td class="type">
          {{ purchaseOrderLine.purchaseOrderNumber }}
        </td>
        <td class="descp">
          {{ purchaseOrderLine.name }}
        </td>
        <td class="descp">
          <a>
            <i
              class="pi pi-truck user-select-auto"
              (click)="redirectToFreightEstimationPage(purchaseOrderLine)"></i
          ></a>
        </td>
        <td class="rest">
          <span *ngIf="purchaseOrderLine.sent | hideEmptyDate">{{
            purchaseOrderLine.sent | date: "MM-dd-yyyy"
          }}</span>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="20">No PO found.</td>
      </tr>
    </ng-template>
  </p-table>

  <ng-template pTemplate="footer">
    <p-button
      icon="pi pi-check"
      (click)="openPrinfPdfTab()"
      label="Ok"
      styleClass="p-button-text"></p-button>
    <p-button
      icon="pi pi-times"
      (click)="closePrinfPdfModal()"
      label="Cancel"
      styleClass="p-button-text"></p-button>
  </ng-template>
</p-dialog>
<jni-modal-stacker
  *ngIf="showFreightEstimationModule"
  [displayModal]="showFreightEstimationModule"
  (closeEvent)="closeFreightEstimationModule()">
  <div class="panelBody">
    <jni-freight-quotation-detail
      [saleOrderId]="purchaseSaleOrderId"
      [purchaseSaleOrderId]="purchaseSaleOrderId"
      [selectedLineItems]="selectedPurchaseOrderLineAddresses"
      (closeModalEvent)="closeFreightEstimationModule()">
    </jni-freight-quotation-detail>
  </div>
</jni-modal-stacker>
